export default "__VITE_ASSET__DHk4NmD$__"